<template>
  <div class="b-foot-datenschutz">
    <div class="button is-primary has-text-white" @click.prevent="toggle">Ausschreibungen</div>
    <div :class="[{'is-active': isActive}, 'modal']">
      <div class="modal-background" @click="close"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Ausschreibungen</p>
        </header>
        <section class="modal-card-body">
          <h6 class="title is-6">(Junior) Administrator Windows (m/w/d)</h6>
          <strong>Ihre Aufgaben:</strong>
          <ul>
            <li>Administration von Windows-Server-Systemen </li>
            <li>Hyper-V Umgebung, Clustering, VDI, RDP</li>
            <li>Monitoring Prometheus und Grafana</li>
            <li>Storage Acronis</li>
            <li>Acronis Backup</li>
            <li>Betrieb von Rechenzentrum-Infrastrukturen</li>
            <li>Automatisierung von Administration und Abläufen durch Scripting</li>
            <li>Implementierung und Betreuung von Cloud-Lösungen</li>
          </ul>
          <br>
          <strong>Ihr Profil:</strong>
          <ul>
            <li>Fundierte Kenntnisse in den Bereichen Server Administration (Windows)</li>
            <li>Gute Kenntnisse in der Netzwerktechnik (Switche, Router, Firewall, DHCP, VPN)</li>
            <li>Hohe Kunden- und Serviceorientierung</li>
            <li>Strukturierte Arbeitsweise und starke analytische Fähigkeiten</li>
            <li>Teamfähigkeit, Flexibilität, hohes Engagement mit selbstständigem und lösungsorientiertem
              Denken und Handeln
            </li>
          </ul>

          <br>
          <h6 class="title is-6">System- und Netzwerkadministrator Linux (m/w/d)</h6>
          <strong>Ihre Aufgaben:</strong>
          <ul>
            <li>Installation, Wartung und Überwachung der Server- und Netzwerkinfrastruktur</li>
            <li>Backup, Restore Management und Netzwerksicherheit</li>
            <li>Betreuung von Anwendern im Rahmen des 1st- und 2nd-Level-Supports</li>
            <li>Übernahme von Rufbereitschaften</li>
          </ul>
          <br>
          <strong>Ihr Profil:</strong>
          <ul>
            <li>Fundierte Kenntnisse in den Bereichen Server Administration (Linux)</li>
            <li>Gute Kenntnisse in der Netzwerktechnik (Switche, Router, Firewall, DHCP, VPN, OSPF, BGP)</li>
            <li>Hohe Kunden- und Serviceorientierung</li>
            <li>Strukturierte Arbeitsweise und starke analytische Fähigkeiten</li>
            <li>Teamfähigkeit, Flexibilität, hohes Engagement mit selbstständigem und lösungsorientiertem
              Denken und Handeln
            </li>
          </ul>
        </section>
        <footer class="modal-card-foot">
          <button class="button" @click="close">Schliessen</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BFootDatenschutz',
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive;
    },
    close() {
      this.isActive = false;
    },
  },
}
</script>

<style lang="scss" scoped>
  .b-foot-datenschutz {
    display: inline;
    text-align: left;
    .modal-card-body {
      ul {
        list-style: initial !important;
        margin: 1em !important;
      }
    }
  }
</style>
